/**
 * Catálogo dos VU meters revisados.
 *
 * `channels` define a topologia de áudio do chartBox. O EP monta os módulos de
 * canal e seus labels automaticamente. `gap: false` mantém todos os canais da
 * mesma fonte unidos no mesmo chartBox.
 *
 * Layouts suportados: 2.0, 2.1, 4.1, 5.1 e 7.1.
 *
 * `bands` pode ser array, um único objeto, null ou undefined.
 * `from` é a API principal; `value` e `start` também são aceitos como aliases.
 */
export const vuQuickCharts = [
  {
    element: 'chart',
    id: 'tutorial-vu-meter',
    type: 'vu',
    channels: '2.0',
    gap: false,
    plotOptions: {
      fast: {
        min: -20,
        max: 6,
        ticks: [-20, -10, 0, 3, 6],
        tickDivisor: 1,
        bands: { color: '#ef4444', value: 0 },
        caption: 'VU'
      }
    }
  }
];

export default vuQuickCharts;
